import { render, staticRenderFns } from "./form-wrap.vue?vue&type=template&id=7d483c25&scoped=true&"
import script from "./form-wrap.vue?vue&type=script&lang=js&"
export * from "./form-wrap.vue?vue&type=script&lang=js&"
import style0 from "./form-wrap.vue?vue&type=style&index=0&id=7d483c25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d483c25",
  null
  
)

export default component.exports